export const library = {
  allArticles: {
    heading: "All articles",
  },
  hero: {
    dek: "Welcome to the tl;dr—that’s the “too long, didn’t read”—summary of all things fertility and pregnancy. Here you’ll find articles on everything from IVF to IUI and all the content you need for trying on your own. We cover diagnoses like PCOS, endometriosis, and male factor infertility, plus lifestyle and wellness choices to support you in your prenatal journey and beyond.",
    heading: "Welcome to the Conceive Library",
  },
  meta: {
    description:
      "All the resources you need when trying to conceive and for pregnancy—fertility treatments like IVF and IUI to diagnoses like PCOS, endometriosis, and male infertility.",
    title: "Library",
  },
  recentlyAdded: {
    heading: "Recently added",
  },
  recommendedArticles: {
    heading: "Recommended for you",
  },
  topics: {
    heading: "Browse by topic",
  },
};
